module.exports = __webpack_public_path__ + "static/img/out6.dec4e20e.png";